import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";
import "../../styles/brand-auth.css";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import MainFooter from "components/Footers/MainFooter.js";
import useReveal from "hooks/useReveal";
import "./LegalPage.css";

/* /accessibility: the accessibility statement, linked from MainFooter.

   Public, like the policies. Same look as LegalPage (navy band, light panel,
   LegalPage.css), but the copy is ours and translated (accessibilityPage.*).
   It states a goal (WCAG 2.2 AA), not conformance, and lists the known gaps.

   Update REVIEWED_ON at each review; docs/launch-checklist.md asks for it
   before launch. */
const REVIEWED_ON = "2026-10-29";

const DONE = ["keyboard", "focus", "announcements", "contrast", "skipLink", "titles"];
const LIMITS = ["editor", "lessonWorkspace", "olderPages", "manualTesting", "studioSites", "stripe"];
// The support page (/contactus), not /contact, which is the sales form.
const CONTACT_PATH = "/contactus";

// "October 29, 2026" / "29 de octubre de 2026".
const formatDate = (isoDate, language) =>
  new Date(`${isoDate}T00:00:00Z`).toLocaleDateString(language, {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });

const AccessibilityPage = () => {
  // The panel's entrance — see styles/premium.css.
  useReveal();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
  }, []);

  return (
    <>
      <DemoNavbar />
      <main id="main" className="cn-cover-page cn-legal">
        <section className="cn-cover cn-grid">
          <span className="cn-grain" aria-hidden="true" />
          <span className="cn-orb cn-orb-1" />
          <span className="cn-orb cn-orb-2" />
          <span className="cn-orb cn-orb-3" />
        </section>

        <Container className="cn-legal-shell">
          <div className="cn-panel cn-legal-panel" data-reveal>
            <h1 className="cn-panel-title">{t("accessibilityPage.title")}</h1>
            <p className="cn-panel-sub">
              {t("accessibilityPage.lastReviewed", { date: formatDate(REVIEWED_ON, i18n.language || "es") })}
            </p>

            <div className="cn-legal-body">
              <p>{t("accessibilityPage.intro")}</p>

              <h2>{t("accessibilityPage.doneTitle")}</h2>
              <ul>
                {DONE.map((item) => (
                  <li key={item}>{t(`accessibilityPage.done.${item}`)}</li>
                ))}
              </ul>

              <h2>{t("accessibilityPage.limitsTitle")}</h2>
              <ul>
                {LIMITS.map((item) => (
                  <li key={item}>{t(`accessibilityPage.limits.${item}`)}</li>
                ))}
              </ul>

              <h2>{t("accessibilityPage.contactTitle")}</h2>
              <p>{t("accessibilityPage.contactBody")}</p>
              <p>
                <a href={CONTACT_PATH}>{t("accessibilityPage.contactLink")}</a>
              </p>

              <h2>{t("accessibilityPage.helpTitle")}</h2>
              <p>{t("accessibilityPage.helpBody")}</p>
            </div>
          </div>
        </Container>
      </main>
      <MainFooter />
    </>
  );
};

export default AccessibilityPage;
